/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import _ from "lodash";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  Button,
  Checkbox,
  Snackbar,
  Alert,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  Box,
  IconButton,
  Autocomplete,
  FormControlLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";
import swal from "sweetalert";
import { connect } from "react-redux";
import { DateTimePicker } from "@mui/lab";

const Card = styled(MuiCard)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function FormDetails({ companies, apCompanies, missingPermissions, auths }) {
  const navigate = useNavigate();
  const [err, setErr] = useState("");
  const [plateCostSum, setPlateCostSum] = useState(0);
  const [success, setSuccess] = useState(false);
  const [searchChallan, setSearchChallan] = useState("");
  const [allChallans, setAllChallans] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectedChallans, setSelectedChallans] = useState({});
  const [down, setDown] = useState({});
  const [loader, setLoader] = useState(false);
  const snackRef = useRef(null);
  const [deliveryAddress, setDeliveryAddress] = useState([]);
  const [lastDate, setLastDate] = useState();
  const [showNtb, setShowNtb] = useState(false);
  const [roundOff, setRoundOff] = useState(true);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [transportCharges, setTransportCharges] = useState(0);
  const [cash_payment, setCashPayment] = useState(false);
  const [hsnCode, setHsnCode] = useState("");

  const [selectedApCompanyId, setSelectedApCompanyId] = useState("");
  const [selectedCustomerCompanyId, setSelectedCustomerCompanyId] = useState("");

  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const selectedCount = () => Object.values(selectedChallans).filter((v) => v === true).length;

  useEffect(() => {
    // Fetch current settings
    const fetchSettings = async () => {
      try {
        const config = {
          headers: { Authorization: `Bearer ${authData.access_token}` },
        };
        const response = await axios.get(
          `/api/v1/${authData.type}/settings`,
          config
        );
        if (response.data.success) {
          setHsnCode(response.data.data.hsn_code || '');
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
        setSnackbar({
          open: true,
          message: 'Failed to load settings',
          severity: 'error',
        });
      }
    };
    fetchSettings();
  }, [])

  const getChalans = async (customerId, apId) => {
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${authData?.type}/challan?customer_company_id=${customerId}&bill_created=NO&ap_company_id=${apId}&populate_job=YES&populate_plate=YES&status=customer_accept&challan_uploaded=YES`,
        config
      );
      if (data.success) {
        const challansWithPrices = await Promise.all(
          data.data.data.map(async (challan) => {
            // Build delivery charge map - works whether job is populated or just ID
            const deliveryChargeMap = {};
            if (challan.job_delivery_charges && Array.isArray(challan.job_delivery_charges)) {
              challan.job_delivery_charges.forEach((item) => {
                // item.job could be an object { _id: ... } or a string ID
                const jobId = item.job?._id || item.job;
                if (jobId) {
                  deliveryChargeMap[jobId.toString()] = item.delivery_charge || 0;
                }
              });
            }

            // Attach delivery_charge to each job
            const jobsWithDelivery = (challan.jobs || []).map((job) => ({
              ...job,
              delivery_charge: deliveryChargeMap[job._id?.toString() || job._id] || 0,
            }));

            // Fetch plate costs (only plate costs now)
            const priceResponse = await axios.post(
              `/api/v1/${authData?.type}/bill/getChallanPrice`,
              { challan_id: challan._id },
              config
            );

            // totalDeliveryCharges might already exist; if not, compute from map
            let totalDelivery = challan.totalDeliveryCharges || 0;
            if (!totalDelivery && Object.keys(deliveryChargeMap).length) {
              totalDelivery = Object.values(deliveryChargeMap).reduce((sum, val) => sum + val, 0);
            }

            return {
              ...challan,
              jobs: jobsWithDelivery,
              plateCost: priceResponse.data.price,
              totalDeliveryCharges: totalDelivery,
            };
          })
        );

        const rowsData = challansWithPrices.map((challan) =>
          createData(
            challan._id,
            challan.challan_id,
            challan.name,
            challan.description,
            challan
          )
        );
        setAllChallans(rowsData);
        setRows(rowsData);
        setSelectedChallans({});
        setPlateCostSum(0);
        setTransportCharges(0);
      }
    } catch (e) {
      console.log(e);
    }
  };

  function setupChallanTableRows() {
    setLoader(true);
    const filtered = allChallans.filter(
      (challan) =>
        challan.challan_id.toLowerCase().startsWith(searchChallan.toLowerCase()) || searchChallan === ""
    );
    setRows(filtered);
    setLoader(false);
  }

  const getLastBillDate = async (ap_company_id) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${userData.type}/bill/last/date/${ap_company_id}`,
        config
      );
      if (data.success) {
        setLastDate(data.data);
      }
    } catch (e) {
      setLoader(false);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
        snackRef.current.click();
      }
    }
  };

  const submit = async (values, resetForm) => {
    try {
      let challans = [];
      Object.keys(selectedChallans).forEach((challan) => {
        if (selectedChallans[challan]) challans.push(challan);
      });
      if (!challans.length) {
        setErr("Select at least one Challan");
        snackRef.current.click();
        return;
      }
      if (challans.length > 10) {
        setErr("Cannot select more than 10 challans");
        snackRef.current.click();
        return;
      }
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userData.type}/bill`,
        {
          name: values.name,
          description: values.description,
          ap_company: values.ap_company,
          customer_company: values.customer_company,
          challans,
          delivery: values.delivery,
          billing_date: new Date(values.billing_date).toISOString(),
          show_not_to_bill: showNtb,
          round_off: roundOff,
          discount_percent: discountPercent,
          transport_charges: transportCharges,
          cash_payment: cash_payment,
          hsn_code: hsnCode,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        setDiscountPercent(0);
        setSelectedChallans({});
        snackRef.current.click();
        resetForm({ values: "" });
        setRows([]);
        navigate("/dashboard/bill", {
          state: { success: true, message: "Bill Created Successfully" },
        });
      }
    } catch (e) {
      setLoader(false);
      if (e.response.data.error) setErr(e.response.data.error);
      else setErr("Server Error");
      snackRef.current.click();
    }
  };

  function createData(id, challan_id, name, description, data) {
    return { id, challan_id, name, description, data };
  }

  function showErrorAlert(message) {
    setErr(message);
    snackRef.current.click();
  }

  function isAnyChallanSelected() {
    return selectedCount() > 0;
  }

  const updatePlateCostSum = (challanId, isChecked) => {
    const challan = allChallans.find((row) => row.id === challanId);
    const plateCost = challan?.data?.plateCost || 0;
    setPlateCostSum((prev) => (isChecked ? prev + plateCost : prev - plateCost));
  };

  useEffect(() => {
    let total = 0;
    Object.keys(selectedChallans).forEach((challanId) => {
      if (selectedChallans[challanId]) {
        const challan = allChallans.find((row) => row.id === challanId);
        total += challan?.data?.totalDeliveryCharges || 0;
      }
    });
    setTransportCharges(total);
  }, [selectedChallans, allChallans]);

  const handleChallanSelect = (e) => {
    const isChecked = e.target.checked;
    const challanId = e.target.name;
    if (isChecked && selectedCount() >= 10) {
      showErrorAlert("You can select a maximum of 10 challans only");
      return;
    }
    setSelectedChallans({
      ...selectedChallans,
      [challanId]: isChecked,
    });
    updatePlateCostSum(challanId, isChecked);
  };

  function checkSelectedDateIsInBetween(selectedDateInput) {
    let challanDates = [];
    Object.keys(selectedChallans).forEach((challan) => {
      if (selectedChallans[challan]) {
        const currentChallan = allChallans.find((it) => it.id === challan);
        challanDates.push(new Date(currentChallan?.data?.challan_date));
      }
    });
    if (challanDates.length === 0) return false;
    challanDates.sort();
    const dateCheck = new Date(selectedDateInput);
    const dateFrom = new Date(challanDates[0]);
    const latestChallanDate = new Date(challanDates[challanDates.length - 1]);
    const dateTo = new Date(latestChallanDate.setFullYear(latestChallanDate.getFullYear() + 1));
    return dateCheck.getTime() <= dateTo.getTime() && dateCheck.getTime() >= dateFrom.getTime();
  }

  function checkSelectedDateGreaterLast(selectedDateInput) {
    const dateCheck = new Date(selectedDateInput);
    if (lastDate !== undefined)
      return dateCheck.setHours(0, 0, 0) < new Date(lastDate.billing_date).setHours(0, 0, 0);
    return false;
  }

  const baseTotal = parseFloat(
    (plateCostSum - (discountPercent > 0 ? (discountPercent * plateCostSum) / 100 : 0) + transportCharges).toFixed(2)
  );

  // FIXED: Correct rounding for cash bills
  let totalWithTax;
  if (cash_payment) {
    // For cash bills, apply rounding directly on the base total
    totalWithTax = roundOff ? Math.round(baseTotal) : baseTotal;
  } else {
    // For non-cash bills, apply rounding after adding 18% tax
    totalWithTax = roundOff
      ? Math.round(baseTotal * 1.18)
      : parseFloat((baseTotal * 1.18).toFixed(2));
  }

  return (
    <>
      <Formik
        initialValues={{
          name: "",
          description: "",
          ap_company: "",
          customer_company: "",
          submit: false,
          billing_date: "",
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required("Bill Name is required"),
          description: Yup.string().required("Description is required"),
          ap_company: Yup.string().required("AP Company is required"),
          customer_company: Yup.string().required("Customer Company is required"),
          billing_date: Yup.string().required("Billing Date is required"),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
          try {
            await submit(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          setFieldValue,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Bill created Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Create Bill
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          name="name"
                          value={values.name}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.name && errors.name)}
                          label="Bill Name"
                          helperText={touched.name && errors.name}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          multiline
                          fullWidth
                          name="description"
                          value={values.description}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.description && errors.description)}
                          label="Description"
                          helperText={touched.description && errors.description}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <FormControl fullWidth error={Boolean(touched.ap_company && errors.ap_company)}>
                          <Autocomplete
                            options={apCompanies}
                            value={values?.ap_company?.name}
                            onChange={(event, newValue) => {
                              const apId = newValue?._id || "";
                              setFieldValue("ap_company", apId);
                              setSelectedApCompanyId(apId);
                              if (selectedCustomerCompanyId && apId) {
                                getChalans(selectedCustomerCompanyId, apId);
                                getLastBillDate(apId);
                              } else {
                                setAllChallans([]);
                                setRows([]);
                                setSelectedChallans({});
                                setPlateCostSum(0);
                                setTransportCharges(0);
                              }
                            }}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.ap_company && errors.ap_company)}
                                helperText={touched.ap_company && errors.ap_company}
                                label="AP Company"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <FormControl fullWidth error={Boolean(touched.customer_company && errors.customer_company)}>
                          <Autocomplete
                            options={companies}
                            value={values?.customer_company?.name}
                            onChange={(event, newValue) => {
                              const custId = newValue?._id || "";
                              setFieldValue("customer_company", custId);
                              setSelectedCustomerCompanyId(custId);
                              setDeliveryAddress(newValue?.addresses || []);
                              if (custId && selectedApCompanyId) {
                                getChalans(custId, selectedApCompanyId);
                              } else {
                                setAllChallans([]);
                                setRows([]);
                                setSelectedChallans({});
                                setPlateCostSum(0);
                                setTransportCharges(0);
                              }
                            }}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.customer_company && errors.customer_company)}
                                helperText={touched.customer_company && errors.customer_company}
                                label="Customer Company"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <FormControl fullWidth error={Boolean(touched.delivery && errors.delivery)}>
                          <Autocomplete
                            options={deliveryAddress}
                            onChange={(event, newValue) => {
                              setFieldValue("delivery", newValue || "");
                            }}
                            onBlur={handleBlur}
                            getOptionLabel={(option) =>
                              `${option?.address_line_one} ${option?.address_line_two} ${option?.city} ${option?.state} - Pincode: ${option?.pincode}`
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.delivery && errors.delivery)}
                                helperText={touched.delivery && errors.delivery}
                                label="Delivery Address"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <FormControl fullWidth error={Boolean(touched.billing_date && errors.billing_date)}>
                          <DateTimePicker
                            renderInput={(props) => (
                              <TextField
                                {...props}
                                error={touched.billing_date && errors.billing_date}
                              />
                            )}
                            label="Billing Date"
                            value={values.billing_date || null}
                            onChange={(newValue) => {
                              if (!isAnyChallanSelected()) {
                                showErrorAlert("Please select a challan first");
                                setFieldValue("billing_date", "");
                                return;
                              }
                              if (!checkSelectedDateIsInBetween(newValue)) {
                                showErrorAlert(
                                  "Please select a date between the oldest challan date and one year from latest challan date"
                                );
                                setFieldValue("billing_date", "");
                                return;
                              }
                              if (checkSelectedDateGreaterLast(newValue)) {
                                showErrorAlert(
                                  `Bill ${lastDate.bill_id} already created with date ${new Date(
                                    lastDate.billing_date
                                  ).toLocaleDateString()} greater than selected date`
                                );
                                setFieldValue("billing_date", "");
                                return;
                              }
                              let selectedDate = newValue;
                              var month = ("0" + parseInt(selectedDate?.getMonth() + 1)).slice(-2);
                              var day = ("0" + parseInt(selectedDate?.getDate())).slice(-2);
                              var hour = parseInt(selectedDate.getHours());
                              var minute = parseInt(selectedDate.getMinutes());
                              let date =
                                selectedDate?.getFullYear() +
                                "-" +
                                month +
                                "-" +
                                day +
                                ":" +
                                hour +
                                ":" +
                                minute;
                              setFieldValue("billing_date", date);
                            }}
                            onBlur={handleBlur}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={2.6} md={2.6}>
                        <FormControl component="fieldset" variant="standard">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={showNtb}
                                onChange={() => setShowNtb(!showNtb)}
                              />
                            }
                            label={"Show not to Bill Plates"}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={2.55} md={2.55}>
                        <FormControl component="fieldset" variant="standard">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={roundOff}
                                onChange={() => setRoundOff(!roundOff)}
                              />
                            }
                            label={"Round off amount"}
                          />
                        </FormControl>
                      </Grid>
                      {(authData.type === "super_admin" || auths.user?.role?.permissions?.includes("create_cash_bill")) && (
                        <Grid item xs={12} lg={2.5} md={2.5}>
                          <FormControl component="fieldset" variant="standard">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={cash_payment}
                                  onChange={() => setCashPayment(!cash_payment)}
                                />
                              }
                              label={"Cash Bill"}
                            />
                          </FormControl>
                        </Grid>
                      )}

                      <Grid item xs={12} lg={12} md={12}></Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="h6">
                            Select Challans For Bill (Max 10)
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <TextField
                              value={searchChallan}
                              onChange={(e) => setSearchChallan(e.target.value)}
                              size="small"
                              sx={{ margin: "0 8px" }}
                              label="Search Challan"
                              placeholder="Challan id"
                            />
                            <Button
                              endIcon={<SearchIcon />}
                              variant="contained"
                              sx={{ mr: 2 }}
                              onClick={setupChallanTableRows}
                            >
                              Search
                            </Button>
                          </Box>
                        </Box>
                        <TableContainer component={Paper}>
                          <Table sx={{ minWidth: 650 }}>
                            <TableHead>
                              <TableRow>
                                <TableCell padding="checkbox"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">Chalan Id</TableCell>
                                <TableCell align="left">Chalan Name</TableCell>
                                <TableCell align="left">Plate Amount</TableCell>
                                <TableCell align="left">Total Delivery Charge</TableCell>
                                <TableCell align="left">Description</TableCell>
                                <TableCell align="left">Chalan Date</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows.map((row) => {
                                return (
                                  <React.Fragment key={row.id}>
                                    <TableRow>
                                      <TableCell padding="checkbox">
                                        <Checkbox
                                          color="primary"
                                          checked={selectedChallans[row.id] || false}
                                          name={row.id}
                                          onChange={handleChallanSelect}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            setDown((prev) => ({ ...prev, [row.id]: !prev[row.id] }));
                                          }}
                                        >
                                          {down[row.id] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                        </IconButton>
                                      </TableCell>
                                      <TableCell>{row.challan_id}</TableCell>
                                      <TableCell>{row.name}</TableCell>
                                      <TableCell>₹{Number(row?.data?.plateCost).toFixed(2)}</TableCell>
                                      <TableCell>₹{Number(row?.totalDeliveryCharges || row?.data?.totalDeliveryCharges)}</TableCell>
                                      <TableCell>{row.description}</TableCell>
                                      <TableCell>
                                        {new Date(row.data.challan_date).toLocaleDateString()} {new Date(row.data.challan_date).toLocaleTimeString()}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                                        <Collapse in={down[row.id]} timeout="auto" unmountOnExit>
                                          <Box sx={{ margin: 1 }}>
                                            <Typography variant="h6" gutterBottom>
                                              Challan Job Details
                                            </Typography>
                                            <Table size="small">
                                              <TableHead>
                                                <TableRow>
                                                  <TableCell>Job ID</TableCell>
                                                  <TableCell>Job Name</TableCell>
                                                  <TableCell align="center">Plate Quantity</TableCell>
                                                  <TableCell>Plate Size</TableCell>
                                                  <TableCell align="center">Delivery Charge</TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {row?.data?.jobs?.map((job, idx) => (
                                                  <TableRow key={idx}>
                                                    <TableCell>{job.job_id}</TableCell>
                                                    <TableCell>{job.name}</TableCell>
                                                    <TableCell align="center">{job.plates?.quantity}</TableCell>
                                                    <TableCell>
                                                      {job.plates?.plate_details?.height || "—"}*
                                                      {job.plates?.plate_details?.width || "—"}*
                                                      {job.plates?.plate_details?.thickness || "—"}
                                                    </TableCell>
                                                    <TableCell align="center">₹{job.delivery_charge || 0}</TableCell>
                                                  </TableRow>
                                                ))}
                                              </TableBody>
                                            </Table>
                                          </Box>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                )
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                      <Box mt={13} px={6} mb={2} width={"100%"}>
                        <Typography variant="h5" gutterBottom>
                          Bill Details
                        </Typography>
                        <TableContainer component={Paper} sx={{ marginTop: "10px" }}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell align="center">Discount Percent</TableCell>
                                <TableCell align="center">Transport Charges</TableCell>
                                <TableCell align="center">HSN Code</TableCell>
                                <TableCell align="center">Total Amount</TableCell>
                                <TableCell align="center">Total Amount with Taxes</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <TextField
                                    fullWidth
                                    value={discountPercent}
                                    onChange={(e) => setDiscountPercent(e.target.value)}
                                    type="number"
                                    InputProps={{ inputProps: { min: 0 } }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    fullWidth
                                    value={transportCharges}
                                    InputProps={{ readOnly: true }}
                                    type="number"
                                    label="Transport Charges (auto)"
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    fullWidth
                                    value={hsnCode}
                                    onChange={(e) => setHsnCode(e.target.value)}
                                    placeholder="e.g. 84439959"
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    fullWidth
                                    value={baseTotal.toFixed(2)}
                                    InputProps={{ readOnly: true }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    fullWidth
                                    value={totalWithTax.toFixed(2)}
                                    InputProps={{ readOnly: true }}
                                  />
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", margin: "10px" }}
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting || missingPermissions.length > 0}
                        >
                          Create Bill
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

const getUserCompanies = async (setCompanies, setApCompanies, setLoader) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const apCompany = await axios.get(`/api/v1/${userData?.type}/ap_company`, config);
    if (apCompany.data.success) {
      setApCompanies(apCompany.data.data.data);
    }
    const { data } = await axios.get(`/api/v1/${userData.type}/customer_company?limit=500`, config);
    if (data.success) {
      setCompanies(data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function CreateBill({ auths }) {
  const [companies, setCompanies] = useState([]);
  const [loader, setLoader] = useState(false);
  const [apCompanies, setApCompanies] = useState([]);
  const [missingPermissions, setMissingPermissions] = useState([]);
  let requiredPermissions = ["view_ap_company_list", "view_customer_company_list"];

  useEffect(() => {
    if (auths?.user) {
      let userPermissions = auths.user?.role?.permissions;
      if (userPermissions) {
        const missing = _.difference(requiredPermissions, userPermissions);
        setMissingPermissions(missing);
        if (missing.length > 0) {
          swal(
            "",
            `You are unauthorized to complete this action because you do not have the following permissions\n\n${_.toUpper(
              missing.join(", ").replace(/_/g, " ")
            )}`,
            "error"
          );
        }
      }
    }
  }, [auths.user]);

  useEffect(() => {
    getUserCompanies(setCompanies, setApCompanies, setLoader);
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid justifyContent="space-between" alignItems="center" container spacing={10} mb={4}>
          <Grid item>
            <Typography variant="h4" gutterBottom display="inline" sx={{ fontWeight: 600 }} color="primary">
              CREATE BILL
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">Dashboard</Link>
              <Link component={NavLink} to="/dashboard/bill">All Bills</Link>
              <Typography>Create Bill</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails
              missingPermissions={missingPermissions}
              apCompanies={apCompanies}
              companies={companies}
              auths={auths}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(CreateBill);